// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Finland */
const FI = /^(?:4946\d{2,6}|(?:4[0-8]|50)\d{4,8})$/;

export default FI;
